import {
  BatterySocStatus,
  type BrakePadStatus,
  EstimatedRangeStatus,
  FuelStatus,
  OilLifeStatus,
} from '~/common/models/asset-report.model';
import { BATTERY_SOC_RANGES } from '~/common/utils/battery.utils';

export const MIN_VALID_ESTIMATED_RANGE_VALUE = 0;
export const MIN_VALID_FUEL_VALUE = 0;
export const MAX_VALID_FUEL_VALUE = 100;

type FuelChargeStatusValue = {
  start?: number;
  end?: number;
  inclusiveStart?: boolean;
  inclusiveEnd?: boolean;
};

//Filter modal status label
export const FUEL_CHARGE_FILTER_MODAL_STATUS: {
  [k in FuelStatus | BatterySocStatus]: FuelChargeStatusValue;
} = {
  [FuelStatus.CRITICAL_FUEL || BatterySocStatus.CRITICAL_CHARGE]: {
    end: 20,
    inclusiveEnd: true,
  },
  [FuelStatus.LOW_FUEL]: {
    start: 21,
    end: 50,
    inclusiveStart: true,
    inclusiveEnd: true,
  },
  [FuelStatus.MEDIUM_FUEL]: {
    start: 51,
    end: 80,
    inclusiveStart: true,
    inclusiveEnd: true,
  },
  [FuelStatus.HIGH_FUEL]: {
    start: 81,
    inclusiveStart: true,
  },
  [BatterySocStatus.LOW_CHARGE]: BATTERY_SOC_RANGES.impaired,
  [BatterySocStatus.MEDIUM_CHARGE]: BATTERY_SOC_RANGES.info0,
  [BatterySocStatus.HIGH_CHARGE]: BATTERY_SOC_RANGES.info1,
};
//Filter modal status label - estimated range in km
export const ESTIMATED_RANGE_MODAL_STATUS: {
  [k in EstimatedRangeStatus]: {
    start?: number;
    end?: number;
    inclusiveStart?: boolean;
    inclusiveEnd?: boolean;
  };
} = {
  [EstimatedRangeStatus.VERY_SHORT_RANGE]: {
    end: 81, //50 mi,
    inclusiveEnd: true,
  },
  [EstimatedRangeStatus.SHORT_RANGE]: {
    start: 82, //51 mi,
    end: 240, //149 mi,
    inclusiveStart: true,
    inclusiveEnd: true,
  },
  [EstimatedRangeStatus.MEDIUM_RANGE]: {
    start: 241, //150 mi,
    end: 481, //299 mi,
    inclusiveStart: true,
    inclusiveEnd: true,
  },
  [EstimatedRangeStatus.LONG_RANGE]: {
    start: 482, //300 mi,
    inclusiveStart: true,
  },
};
export const OIL_LIFE_FILTER_MODAL_STATUS: {
  [k in OilLifeStatus]: {
    start?: number;
    end?: number;
  };
} = {
  [OilLifeStatus.GOOD]: {
    start: 21,
  },
  [OilLifeStatus.IMPAIRED]: {
    start: 6,
    end: 20,
  },
  [OilLifeStatus.CRITICAL]: {
    end: 5,
  },
};

export const BRAKE_PAD_FILTER_MODAL_STATUS: {
  [k in BrakePadStatus]: {
    start?: number;
    end?: number;
  };
} = {
  [OilLifeStatus.GOOD]: {
    start: 25,
  },
  [OilLifeStatus.IMPAIRED]: {
    start: 15,
    end: 25,
  },
  [OilLifeStatus.CRITICAL]: {
    end: 15,
  },
};
